const DISPLAY_ACTIVITY_SERIES = [
  'revenue',
  'draw',
  'repay',
  'endBal',
  'xirrFee',
  'facFeeRow',
  'directMarketing',
  'ebitda',
  'twelveCF',
  'cashEnd',
  'twelveFinance',
  'cogs',
  'grossProfit',
  'contribution',
  'opexRow',
  'runrate',
  'runoff',
  'runoffCohortWindow',
];

/**
 * Last output month index (inclusive) with any non-zero value in the main results
 * series. N_OUT is often longer than this because it must cover repayment tails,
 * payback horizons, and facility-fee timing for the calc engine.
 */
export function resolveLastDisplayedOutputMonth(calcResult) {
  if (!calcResult?.N_OUT) {
    return 0;
  }

  let lastMonth = 0;
  for (let month = 0; month < calcResult.N_OUT; month += 1) {
    const hasActivity = DISPLAY_ACTIVITY_SERIES.some((key) => {
      const value = Number(calcResult[key]?.[month]) || 0;
      return value !== 0;
    });
    if (hasActivity) {
      lastMonth = month;
    }
  }
  return lastMonth;
}

export function resolveDisplayedOutputMonthCount(calcResult) {
  return resolveLastDisplayedOutputMonth(calcResult) + 1;
}
